import React from 'react';
import { ProgressBar } from './StepperTimeline.styled';

interface StepperTimelineProps {
  currentStep: number;
  totalSteps: number;
}

export const StepperTimeline = ({
  currentStep,
  totalSteps,
}: StepperTimelineProps) => {
  return (
    <ProgressBar
      component="progress"
      data-testid="stepper-timeline"
      value={currentStep}
      max={totalSteps}
    />
  );
};
